import { Button, Badge } from 'antd';
import _ from 'lodash';
import get from 'lodash/get';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import { Routes } from '../helpers/_routes';
import I18n from '../i18n';
import AppContext from '../services/Context';
import styled from '../styled-components';
import OnboardingVideos from './OnboardingVideosComponent';
//importing permissions
import { oldSideNavPermissions }  from '../services/permissions/oldPermissions';
import { newSideNavPermissions } from '../services/permissions/newPermissions';
import { isFilledArray } from '@src/helpers/validation/arrayValidators';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

const LogoImg = require('../images/goepik-logo.png');

type PropType = { history: { replace: Function }; location: { pathname: string } };


export default withRouter((props: PropType) => (
  <AppContext.Consumer>
    {({ theme, locale, units, token, client, pillar, roles, user, visibleOnboarding, onChangeVisibleOnboarding, userPermissions, defaultPermissions, scheduled }) => {
      const myRoles = roles;
      let validPermissions: any = []
      if(isFilledArray(userPermissions)){
        const newPermissions = userPermissions.map((r: any) => [...r.permissions]).values()
        let allPermissions: any = []
        for (let np of newPermissions) {
          allPermissions = [...allPermissions, ...np]
        }
        validPermissions = defaultPermissions.map((v: any) => {
          const isOk = allPermissions.some((p: any) => {
            const is = p.group_permission_id === v.id && [1, 2].includes(p.rule)
            return is
          })
          const n = v
          n.canAccess = isOk
          return n
        })
      }
      const _permission = (roles: string[], pillars: string[], route?: string): boolean => {
        
        if(pillar !== 'LI'){
          return oldSideNavPermissions({pillars, roles}, pillar, token);
        } else {
          return newSideNavPermissions(pillars, validPermissions, route);
          // return true;
        }
      }

      const AppVersion = process.env.APP_VERSION;
      const AppClient = location.host.substr(0, location.host.indexOf('.'));
      return (
        <Wrapper theme={theme}>
          <LogoContainer theme={theme}>
            <Link to='/'>
              <Logo src={LogoImg} alt="" />
            </Link>
          </LogoContainer>
          <Nav>
            {_permission(['ADMIN', 'READER', 'MANAGER'], ['EHSS'], Routes.dashboard) && (
              <NavItem
                theme={theme}
                className={props.location.pathname === Routes.dashboard ? 'active' : ''}
              >
                <Link to={Routes.dashboard}>{I18n.l('routes.dashboard')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'READER', 'MANAGER', 'AUDITOR', 'ASSIGNMENT'], ['LI', 'EHSS'], Routes.liteReports) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.liteReports) > -1 ? 'active' : ''}
              >
                <Link to={Routes.liteReports}>{pillar === 'EHSS' ? I18n.l('dashboard.lite') : I18n.l('routes.dashboard')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'READER', 'MANAGER', 'ASSIGNMENT'], ['EHSS', 'QA', 'LI'], Routes.processManagement) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.processManagement) > -1 ? 'active' : ''}
              >
                <Link to={Routes.processManagement}> {pillar === 'EHSS' && I18n.l('routes.processManagement')} {pillar !== 'EHSS' && I18n.l('labels.processmanagement')} </Link>
              </NavItem>
            )}
            {_permission(['ADMIN'], ['QAFS'], Routes.distributors) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.distributors) > -1 ? 'active' : ''}
              >
                <Link to={Routes.distributors}>{I18n.l('routes.distributors')}</Link>
              </NavItem>
            )}
             {_permission(['ADMIN'], ['ADMIN'], Routes.distributors) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.distributors) > -1 ? 'active' : ''}
              >
                <Link to={Routes.distributors}>{I18n.l('routes.distributors')}</Link>
              </NavItem>
            )}
            
            {_permission(['DISTRIBUTOR'], ['QAFS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.agentsMe) > -1 ? 'active' : ''}
              >
                <Link to={Routes.agentsMe}>{I18n.l('routes.meAgents')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN'], ['QAFS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.agentsAdmin) > -1 ? 'active' : ''}
              >
                <Link to={Routes.agentsAdmin}>{I18n.l('routes.meAgents')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN'], ['QAFS', 'QA', 'CM', 'EHSS', 'LI', 'ADMIN'], Routes.users) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.users) > -1 ? 'active' : ''}
              >
                <Link to={Routes.users}>{I18n.l('routes.users')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN'], ['QAFS', 'QA', 'CM']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.products) > -1 ? 'active' : ''}
              >
                <Link to={Routes.products}>{I18n.l('routes.products')}</Link>
              </NavItem>
            )}

            {_permission(['ADMIN', 'READER', 'MANAGER'], ['QA']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.productionLines) > -1 ? 'active' : ''}
              >
                <Link to={Routes.productionLines}>{I18n.l('routes.productionLines')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'READER', 'MANAGER'], ['QA']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.workstations) > -1 ? 'active' : ''}
              >
                <Link to={Routes.workstations}>{I18n.l('routes.workstations')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'MANAGER', 'AUDITOR'], ['EHSS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.auditors) > -1 ? 'active' : ''}
              >
                <Link to={Routes.auditors}>{I18n.l('routes.auditors')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'MANAGER'], ['EHSS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.auditeds) > -1 ? 'active' : ''}
              >
                <Link to={Routes.auditeds}>{I18n.l('routes.auditeds')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'MANAGER'], ['EHSS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.assignment) > -1 ? 'active' : ''}
              >
                <Link to={Routes.assignment}>{I18n.l('routes.assignment')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'MANAGER'], ['EHSS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.manager) > -1 ? 'active' : ''}
              >
                <Link to={Routes.manager}>{I18n.l('routes.manager')}</Link>
              </NavItem>
            )}

            {_permission(['ADMIN'], ['EHSS', 'QA', 'LI'], Routes.formflowProcess) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.formflowProcess) > -1 ? 'active' : ''}
              >
                <Link to={Routes.formflowProcess}>  {pillar === 'EHSS' && I18n.l('routes.formflowProcess')} {pillar !== 'EHSS' && I18n.l('labels.processTitle')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN'], ['EHSS', 'LI'], Routes.workflows) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.workflows) > -1 ? 'active' : ''}
              >
                <Link to={Routes.workflows}>{I18n.l('routes.workflows')}</Link>
              </NavItem>
            )}

            {_permission(['ADMIN'], ['EHSS', 'QA', 'QAFS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.profile) > -1 ? 'active' : ''}
              >
                <Link to={Routes.profile}>{I18n.l('routes.profile')}</Link>
              </NavItem>
            )}
            
            {_permission(['ADMIN'], ['ADMIN']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.client) > -1 ? 'active' : ''}
              >
                <Link to={Routes.client}>{I18n.l('Clientes')}</Link>
              </NavItem>
            )}
            {_permission(['DISTRIBUTOR'], ['QAFS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.history) > -1 ? 'active' : ''}
              >
                <Link to={Routes.history}>{I18n.l('routes.history')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN'], ['QAFS']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.adminHistory) > -1 ? 'active' : ''}
              >
                <Link to={Routes.adminHistory}>{I18n.l('routes.history')}</Link>
              </NavItem>
            )}

            {_permission(['ADMIN', 'READER', 'MANAGER'], ['QA', 'LI'], Routes.model3d) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.model3d) > -1 ? 'active' : ''}
              >
                <Link to={Routes.model3d}>{I18n.l('routes.model3d')}</Link>
              </NavItem>
            )}

            {_permission(['CM', 'ADMIN'], ['CM']) && (

              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.alerts) > -1 ? 'active' : ''}
              >
                <Link to={Routes.alerts}>{I18n.l('routes.alerts')}</Link>
              </NavItem>
            )}
            {_permission(['CM', 'ADMIN'], ['CM']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.links) > -1 ? 'active' : ''}
              >
                <Link to={Routes.links}>{I18n.l('routes.alertsLink')}</Link>
              </NavItem>
            )}

            {_permission(['ADMIN'], ['EHSS', 'QA', 'QAFS', 'LI'], Routes.targets) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.targets) > -1 ? 'active' : ''}
              >
                <Link to={Routes.targets}>{I18n.l('routes.targets')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'READER', 'MANAGER'], ['QA']) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.qaHistory) > -1 ? 'active' : ''}
              >
                <Link to={Routes.qaHistory}>{I18n.l('routes.ehssHistory')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'READER', 'MANAGER'], ['LI'], Routes.scheduler) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.scheduler) > -1 ? 'active' : ''}
              >
                <Link to={Routes.scheduler}>{I18n.l('routes.scheduler')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'READER', 'MANAGER'], ['EHSS', 'LI'], Routes.ehssHistory) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.ehssHistory) > -1 ? 'active' : ''}
              >
                <Link to={Routes.ehssHistory}>{I18n.l('routes.ehssHistory')}</Link>
              </NavItem>
            )}
            {_permission(['ADMIN', 'READER', 'MANAGER'], ['LI'], Routes.my_processes) && (
              <NavItem
                theme={theme}
                className={props.location.pathname.indexOf(Routes.my_processes) > -1 ? 'active' : ''}
              >
                <LinkMyProcesses to={Routes.my_processes}>{I18n.l('routes.my_processes')} {scheduled && (
                  <Badge count={<Icon icon={faCircle} />}>
                  </Badge>
                )}</LinkMyProcesses>
              </NavItem>
            )}

          </Nav>
          <SidebarFooter>
            {pillar === 'LI' &&
              <Button style={{ width: '100%', marginBottom: '1rem' }} onClick={() => onChangeVisibleOnboarding()} ghost >{I18n.l('label.goepikGuide').toUpperCase()}</Button>
            }
            <p>goepik v{AppVersion} - {AppClient}</p>
          </SidebarFooter>
          <OnboardingVideos visibleOnboarding={visibleOnboarding} toggleOnboardingModal={() => onChangeVisibleOnboarding} />
        </Wrapper>

      );
    }}
  </AppContext.Consumer>
));

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background: ${({ theme }) => theme.sidebarBackground};
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 180px;
  z-index: 4;
  overflow: auto;  
`;

const SidebarFooter = styled.div`
    text-align: left;
    padding: 20px 30px 20px 20px;
    font-size: 10px;
    width: 100%;
`;

const LogoContainer = styled.div`
  background: ${({ theme }) => theme.logoBackground};
  flex: ${({ theme }) => `0 0 ${theme.headerHeight}` || '0 0 150px'};
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: 100%;
    a{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const Logo = styled.img`
  width: 35%; 
  max-width: 80%;
  max-height: 80%;
`;

const Nav = styled.ul`
  flex: 1;
  margin: 0;
  padding: 40px 0 0 0;
  width: 100%;

  .select-dropdown-display {
    color: #333;
  }
  .form-input-label {
    color: #fff;
  }
`;

const NavItem = styled.li`
  background: ${({ theme }) => get(theme, 'nav.background') || 'transparent'};
  color: ${({ theme }) => get(theme, 'nav.color') || '#fff'};
  cursor: pointer;
  margin: 0;
  
  list-style: none;
  width: 100%;
  text-transform: ${({ theme }) => get(theme, 'nav.textTransform') || 'lowercase'};
  
  a {
      color: ${({ theme }) => get(theme, 'nav.color') || '#fff'};
      padding: ${({ theme }) => get(theme, 'nav.padding') || '10px'};
      display: block;
  }
  &.active,
  &:hover {
    background: ${({ theme }) => get(theme, 'clientColor') || 'transparent'};
    color: ${({ theme }) => get(theme, 'nav.colorHover') || '#fff'};
    a {
        color: ${({ theme }) => get(theme, 'nav.colorHover') || '#fff'};
        text-decoration: none
    }
  }
`;

const LinkMyProcesses = styled(Link)`
  position: relative;
  .ant-badge {
    position: absolute;
    width: 5px;
    color: red;
    font-size: 10px;
  }
`
